import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { DataBagService } from 'src/app/common/data-bag.service';
import { Data2Service } from 'src/app/common/data2.service';
import { DateService } from 'src/app/common/date.service';

import { AccommodationService, MoveData } from '../accommodation.service';
import { AccommodationListReservationComponent } from './accommodation-list-reservation/accommodation-list-reservation.component';
import { QuestionService } from 'src/app/common/question-dialog/question-dialog.service';
import { LoaderService } from 'src/app/common/loader/loader.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { MatDialog } from '@angular/material/dialog';
import { AccommodationListProductsComponent } from './accommodation-list-products/accommodation-list-products.component';

@Component({
	selector: 'app-accommodation-list',
	templateUrl: './accommodation-list.component.html',
	styleUrls: ['./accommodation-list.component.css'],
})
export class AccommodationListComponent implements OnInit, OnDestroy, AfterViewInit {
	@ViewChild(AccommodationListReservationComponent)
	reservationComponent: AccommodationListReservationComponent;
	private readonly subscriptions = {
		queryParms: null,
		service: null,
		move: null,
	};
	show = {
		noname: false,
		terms: false,
		subrooms: false,
		unassigned: false,
	};
	months: any[] = [];
	destinations: Array<any> = [];
	moveButtons: Array<any> = [];
	private moveReservation;
	occupancy = [];

	constructor(
		public service: AccommodationService,
		private readonly erp: Data2Service,
		private readonly bag: DataBagService,
		private readonly date: DateService,
		private readonly infobox: InfoboxService,
		private readonly loader: LoaderService,
		private readonly question: QuestionService,
		private readonly route: ActivatedRoute,
		private readonly router: Router,
		private readonly dialog: MatDialog,
	) {}

	ngOnInit(): void {
		if (!this.route.snapshot.queryParams['date']) {
			const queryParams = { ...this.route.snapshot.queryParams };
			queryParams.date = this.date.now().date;
			this.router.navigate(['.'], {
				relativeTo: this.route,
				queryParams: queryParams,
				preserveFragment: true,
			});
			return;
		}
		this.subscriptions.queryParms = this.route.queryParams.subscribe((parms) => {
			if (parms.date && parms.date != this.service.date) {
				this.service.date = parms.date;
				this.months = this.generateMonths();
				this.loadData();
			}
			if (parms.products && parms.products != this.service.productsSelected.join(',')) {
				this.service.productsSelected = parms.products.split(',').map((obj) => Number(obj));
				this.loadAccomodations();
			}
			if (parms.destination && parms.destination != this.service.destination) {
				this.service.destination = parms.destination;
			}
			this.loadProducts();
		});
		this.subscriptions.move = this.service.move.subscribe((data: MoveData) => {
			this.reservationEvent(data);
		});
		this.loadRoomTypes();
		this.loadLocations();
	}

	ngOnDestroy(): void {
		if (this.subscriptions.queryParms) {
			this.subscriptions.queryParms.unsubscribe();
		}
	}

	ngAfterViewInit(): void {
		this.service.checkerSize.width = document.getElementsByClassName('navbar')[0].clientWidth - 340 - 20;
	}

	private loadLocations(): void {
		this.erp.get('/bag/bagLocations/', (result, error) => {
			this.destinations = result.data;
		});
	}

	private loadRoomTypes(): void {
		this.bag.get('/product/room/type/?limit=200', (result, error) => {
			this.service.roomTypes = result.results;
		});
	}

	protected loadProducts() {
		this.loader.show('loadProducts');
		const locationIn = this.service.destination ? `&location__id__in=${this.service.destination}` : '';
		this.bag.get(`/product/?limit=200&product_kind__id__in=1,2,5,6,7,8,9${locationIn}`, (result, error) => {
			this.service.productsAll = result.results;
			this.loader.hide('loadProducts');
			if (this.service.destination) {
				this.service.productsSelected = this.service.productsAll.map((obj) => obj.id);
				this.loadAccomodations();
			}
		});
	}

	private loadAccomodations() {
		if (!this.service.productsSelected.length) {
			return;
		}
		const locationIn = this.service.destination ? `&location__id__in=${this.service.destination}` : '';
		this.service.roomsProducts = [];
		this.loader.show();
		this.bag.get(
			`/product/accommodation_file/?limit=999999&product=${this.service.productsSelected}${locationIn}`,
			(result, error) => {
				this.service.products = result.results.map((obj) => {
					obj.reservations = [];
					obj.availabilities = [];
					obj.unassigned = [];
					obj.unassignedRows = 0;
					const occupancy = this.occupancy.find((objFind) => objFind.bookProductId == obj.id);
					obj.occupancy = !!occupancy ? occupancy.capacityOccupancy : 0;
					obj.rooms.forEach((room) => {
						this.service.roomsProducts.push({
							room: room,
							product: obj,
						});
						const ocupatedRoom = occupancy?.rooms.find((objFind) => objFind.roomId == room.id);
						room.occupancy = !!ocupatedRoom ? ocupatedRoom.capacityOccupancy : 0;

						if (this.show.subrooms == true) {
							room.roomSlaves.forEach((roomSlaves) => {
								this.service.roomsProducts.push({
									room: roomSlaves,
									product: obj,
								});
							});
						}
					});
					return obj;
				});
				this.loader.hide();
				this.loadData();
			},
		);
	}

	private loadData() {
		if (!this.service.date) {
			return;
		}
		if (!this.service.products.length) {
			return;
		}
		if (!this.service.checkerSize.width) {
			return;
		}
		this.loader.show();
		this.loadReservations();
		this.service.loadAvailabilities();
	}

	loadAvability() {
		this.show.subrooms = !this.show.subrooms;
		this.loadAccomodations();
	}

	private loadReservations() {
		this.loader.show('loadReservations');
		this.service.nonames = [];
		this.service.nonamesRows = 0;
		this.service.products.forEach((product) => {
			product.unassigned = [];
			product.reservations = [];
		});
		const parms: string = 'date=' + this.service.date + '&location=' + this.service.destination;
		this.erp.get('/istour/istourAccommodations/?' + parms, (result, error) => {
			if (error) {
				return;
			}
			this.service.parseReservations(result);
			this.loader.hide('loadReservations');
		});
	}

	protected productsOpen() {
		const dialog = this.dialog
			.open(AccommodationListProductsComponent)
			.afterClosed()
			.subscribe((result) => {
				dialog.unsubscribe();
				if (!result) {
					return;
				}
				const queryParams = { ...this.route.snapshot.queryParams };
				queryParams.products = result.join(',');
				this.router.navigate(['.'], {
					relativeTo: this.route,
					queryParams: queryParams,
					preserveFragment: true,
				});
			});
	}

	protected destinationChange(newValue) {
		const queryParams = { ...this.route.snapshot.queryParams };
		queryParams.destination = newValue;
		this.router.navigate(['.'], {
			relativeTo: this.route,
			queryParams: queryParams,
			preserveFragment: true,
		});
	}

	setDate(): void {
		this.router.navigate([this.route.snapshot.url[0].path, this.service.date]);
	}

	dateMove(days) {
		const newDate = this.date.daysAdd(days, this.service.date);
		this.router.navigate([this.route.snapshot.url[0].path, newDate]);
	}

	reservationSelected(reservation) {
		if (this.service.reservationQuartering) {
			this.service.move.next({
				type: 'dok',
				step: 'end',
				reservation: null,
			});
		}
		this.reservationComponent.open(reservation);
	}

	reservationMoveStart(reservation) {
		if (!reservation.istourRoomCode) {
			this.checkAvailability(reservation);
			return;
		}
		const question = this.question
			.ask('To jest rezerwacja z gwarancją pokoju. Czy na pewno przenieść?', 'reservationMoveStart')
			.subscribe((result) => {
				if (result.dialogId !== 'reservationMoveStart') {
					return;
				}
				question.unsubscribe();
				if (!result.result) {
					return;
				}
				this.checkAvailability(reservation);
			});
	}

	private checkAvailability(reservation) {
		this.moveReservation = reservation;
		if (reservation.room) {
			if (reservation.noname != '0') {
				this.resevationToNoname(reservation);
				return;
			}
			this.reservationToCart(reservation);
			return;
		}
		// let roomType = this.service.roomTypes.find(obj => obj.id == reservation.roomType)
		const products =
			reservation.noname != '0'
				? this.service.products
				: this.service.products.filter((obj) => obj.id == reservation.productId);
		this.showAvailableRooms(products, reservation);
	}

	private showAvailableRooms(products, reservation) {
		this.moveButtons = [];
		products.forEach((product) => {
			product.rooms.forEach((room) => {
				this.moveButtons.push({
					room,
					reservation,
					style: {
						'top.px': document.getElementById('room' + room.id).offsetTop,
					},
				});
			});
		});
	}

	moveHere(button) {
		this.moveButtons = [];
		this.erp.put(
			'/istour/istourAccommodations/' + button.reservation.id,
			{
				room: button.room.id,
				dateFrom: button.reservation.dateFrom,
				dateTo: button.reservation.dateTo,
			},
			(result, error) => {
				if (error) {
					return;
				}
				this.service.reservationToLodge(button.reservation, button.room);
				this.moveReservation = null;
			},
		);
	}

	private reservationEvent(data) {
		switch (data.type) {
			case 'dok':
				switch (data.step) {
					case 'end':
						this.loadReservations();
						break;
				}
				break;
			case 'changeProduct':
				switch (data.step) {
					case 'begin':
						this.moveReservation = data.reservation;
						this.showAvailableRooms(this.service.products, data.reservation);
						break;
				}
				break;
		}
	}

	private resevationToNoname(reservation) {
		this.erp.put(
			'/istour/istourAccommodations/' + this.moveReservation.id,
			{ toNoname: true, quartering: this.moveReservation.quartering },
			(result, error) => {
				if (error) {
					return;
				}
				if (this.moveReservation.quartering) {
					this.moveReservation = null;
					this.loadProducts();
					return;
				}
				this.service.resevationToNoname(reservation);
				this.moveReservation = null;
			},
		);
	}

	private reservationToCart(reservation) {
		this.erp.put('/istour/istourAccommodations/' + this.moveReservation.id, { room: null }, (result, error) => {
			if (error) {
				return;
			}
			this.service.reservationToCart(reservation);
			this.moveReservation = null;
		});
	}

	private generateMonths(): Array<any> {
		const now = new Date(this.service.date);
		let firstDay;
		const results: Array<any> = [];
		for (let addMonths = 0; addMonths < 3; addMonths++) {
			firstDay = new Date(now.getFullYear(), now.getMonth() + addMonths, 1);
			results.push({
				name: firstDay.toLocaleString('default', { month: 'long' }) + ' ' + firstDay.getFullYear(),
				from: 1,
				days: this.date.daysInMonth(firstDay),
			});
		}
		results[0].from = now.getDate();
		return results;
	}
}
